export default __webpack_public_path__ + "static/media/ambiente-dNC.46f544b4.svg";